gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MorphSVGPlugin);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(SplitText);

// set defaults

ScrollTrigger.defaults({
    markers: false
});